'use client';

import { 
  IoFingerPrintSharp, 
  IoLayersSharp, 
  IoFolderSharp, 
  IoShieldCheckmarkSharp,
  IoCropSharp,
  IoCloudSharp,
  IoCubeSharp
} from 'react-icons/io5';
import { IoLogoApple } from 'react-icons/io';
import styles from '../styles/Services.module.css';

const Services = () => {
  return (
    <section className={styles.services} id="services">
      <div className={styles.servicesCol}>
        <p className="callout">We work with</p>
      </div>
      <div className={styles.servicesCol}>
        <div className={styles.servicesRow}>
          <div className={styles.serviceItem}>
            <div className={styles.serviceIcon}>
              <IoFingerPrintSharp />
            </div>
            <div className={styles.serviceTitle}>
              <p>Authy</p>
            </div>
          </div>
          <div className={styles.serviceItem}>
            <div className={styles.serviceIcon}>
              <IoLayersSharp />
            </div>
            <div className={styles.serviceTitle}>
              <p>Design</p>
            </div>
          </div>
          <div className={styles.serviceItem}>
            <div className={styles.serviceIcon}>
              <IoFolderSharp />
            </div>
            <div className={styles.serviceTitle}>
              <p>Storage</p>
            </div>
          </div>
          <div className={styles.serviceItem}>
            <div className={styles.serviceIcon}>
              <IoShieldCheckmarkSharp />
            </div>
            <div className={styles.serviceTitle}>
              <p>Security</p>
            </div>
          </div>
        </div>
        <div className={styles.servicesRow}>
          <div className={styles.serviceItem}>
            <div className={styles.serviceIcon}>
              <IoLogoApple />
            </div>
            <div className={styles.serviceTitle}>
              <p>Development</p>
            </div>
          </div>
          <div className={styles.serviceItem}>
            <div className={styles.serviceIcon}>
              <IoCropSharp />
            </div>
            <div className={styles.serviceTitle}>
              <p>Editing</p>
            </div>
          </div>
          <div className={styles.serviceItem}>
            <div className={styles.serviceIcon}>
              <IoCloudSharp />
            </div>
            <div className={styles.serviceTitle}>
              <p>Cloud</p>
            </div>
          </div>
          <div className={styles.serviceItem}>
            <div className={styles.serviceIcon}>
              <IoCubeSharp />
            </div>
            <div className={styles.serviceTitle}>
              <p>Blockchain</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services; 